import React from "react";
import Checkbox from "../components/Checkbox";
import Header from "../components/Header";
import { FIELD_ERROR_TEXT, PROVINCES_LIST } from "../utils";
import BranchDetails from "./existing/BranchDetails";
import TextField from "../components/TextField";
import Dropdown from "../components/Dropdown";
import canadaFlag from "../assets/CanadaFlag.jpg";
import ApplicationInformation from "./existing/ApplicantInformation";

const Initial = ({
  data,
  setData,
  error,
  handleInputChange,
  offlineDisabled,
  handleSelect,
  disabled,
  btnLoading,
}) => {
  return (
    <div>
      {/* <Header text="Registration Type" /> */}

      <div className="form_container">
        <Checkbox
          label={"Registration"}
          firstoption="Download Registration Form"
          secondoption="Complete Registration Online"
          required
          handleChangeFirst={handleInputChange}
          handleChangeSecond={handleInputChange}
          value={data?.register_as}
          name="register_as"
          error_text={FIELD_ERROR_TEXT}
          error_state={error?.register_as}
          disabled={disabled?.stage || btnLoading}
        />
      </div>

      {data?.register_as === "Download Registration Form" ? (
        <div>
        <BranchDetails
          data={data}
          setData={setData}
          handleInputChange={handleInputChange}
          error={error}
          offlineDisabled={offlineDisabled}
          // disabled={offlineDisabled || disabled?.stage || btnLoading}
        />
        <ApplicationInformation data={data}  handleInputChange={handleInputChange} error={error} offlineDisabled={offlineDisabled}   />
        </div>
      ) : (
        ""
      )}

      {data?.register_as === "Complete Registration Online" ? (
        <div>
          <Header text="Brokerage / Branch Details" />

          <div className="form_container">
            <TextField
              label="Legal Name of Brokerage"
              name="legal_name_of_brokage"
              value={data?.legal_name_of_brokage}
              handleChange={handleInputChange}
              error_state={error?.legal_name_of_brokage}
              error_text={FIELD_ERROR_TEXT}
              required
              disabled={offlineDisabled || disabled?.stage || btnLoading}
            />
            <TextField
              label="Operating Name"
              name="operating_name"
              value={data?.operating_name}
              handleChange={handleInputChange}
              required
              error_state={error?.operating_name}
              error_text={FIELD_ERROR_TEXT}
              disabled={offlineDisabled || disabled?.stage || btnLoading}
            />
          </div>

          <div className="form_container">
            <div className="fs_14">
              By signing up, you will be able to quote, bind coverage and have
              policy documents within minutes. Renewals will also be automated
              to save you time!
            </div>

            <div className="fs_14">
              All brokerages must provide a generic email for all correspondence
              with regards to each policy. All correspondence sent to brokerage
              will be sent to both the general and brokers email. ( to fill in
              the marked blank )
            </div>

            <div className="fs_14 mb_16">
              Please note: The general email address cannot be used to create a
              user account. Each user must register with a unique email address
              that is different from the general email address provided below.
            </div>

            <div className="mb_16">
              <TextField
                label="General Email Address"
                helperText="Required for general policy deliverance"
                name="general_email"
                value={data?.general_email}
                handleChange={handleInputChange}
                error_state={error?.general_email}
                error_text={
                  data?.general_email && error?.general_email
                    ? "Please enter valid email"
                    : FIELD_ERROR_TEXT
                }
                custom="email"
                disabled={offlineDisabled || disabled?.stage || btnLoading}
              />
            </div>
          </div>
          <div  >
            <ApplicationInformation data={data}  handleInputChange={handleInputChange} error={error} offlineDisabled={offlineDisabled}   />

           </div>
           
      

          <div style={{marginTop : "40px"}}>
            <Header text="Head Office Details"  />

            <div className="form_container" style={{ paddingBottom: "0" }}>
              <TextField
                label="Head Office Phone Number"
                name="ho_phone_number"
                value={data?.ho_phone_number}
                handleChange={handleInputChange}
                error_state={error?.ho_phone_number}
                custom="phone"
                error_text={
                  data?.ho_phone_number && error?.ho_phone_number
                    ? "Please enter valid phone"
                    : FIELD_ERROR_TEXT
                }
                required
                addonBefore={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: ".875rem",
                      fontWeight: "600",
                    }}
                  >
                    <img
                      style={{ height: "0.75rem", opacity: "0.7" }}
                      src={canadaFlag}
                      alt=""
                    />
                    <span>+1</span>
                  </div>
                }
                disabled={offlineDisabled || disabled?.stage || btnLoading}
              />
              <p className="secondary_title">Head Office Address</p>
              <TextField
                label="Street Address"
                name="ho_street"
                value={data?.ho_street}
                handleChange={handleInputChange}
                error_state={error?.ho_street}
                error_text={FIELD_ERROR_TEXT}
                required
                disabled={offlineDisabled || disabled?.stage || btnLoading}
              />
              <TextField
                label="Address Line 2"
                name="ho_line2"
                value={data?.ho_line2}
                handleChange={handleInputChange}
                error_state={error?.ho_line2}
                error_text={FIELD_ERROR_TEXT}
                disabled={offlineDisabled || disabled?.stage || btnLoading}
              />
              <Dropdown
                label="Country"
                name="ho_country"
                value={data?.ho_country}
                handleChange={(value) =>
                  handleSelect({ value, name: "ho_country" })
                }
                options={[{ label: "Canada", value: "Canada" }]}
                error_state={error?.ho_country}
                required
                error_text={FIELD_ERROR_TEXT}
                disabled={offlineDisabled || disabled?.stage || btnLoading}
              />{" "}
              <Dropdown
                label="Province"
                name="ho_province"
                value={data?.ho_province}
                handleChange={(value) =>
                  handleSelect({ value, name: "ho_province" })
                }
                options={PROVINCES_LIST}
                error_state={error?.ho_province}
                error_text={FIELD_ERROR_TEXT}
                required
                disabled={offlineDisabled || disabled?.stage || btnLoading}
              />
              {/* <Dropdown
                label="City"
                name="ho_city"
                value={data?.ho_city}
                options={[{ label: "Toronto", value: "Toronto" }]}
                handleChange={(value) =>
                  handleSelect({ value, name: "ho_city" })
                }
                error_state={error?.ho_city}
                error_text={FIELD_ERROR_TEXT}
                required
                disabled={offlineDisabled || disabled?.stage || btnLoading}
              /> */}
              <TextField
                label="City"
                name="ho_city"
                value={data?.ho_city}
                handleChange={handleInputChange}
                error_state={error?.ho_city}
                error_text={FIELD_ERROR_TEXT}
                required
                disabled={offlineDisabled || disabled?.stage || btnLoading}
              />
              <TextField
                label="Postal Code"
                name="ho_pc"
                value={data?.ho_pc}
                handleChange={handleInputChange}
                error_state={error?.ho_pc}
                error_text={
                  data?.ho_pc && error?.ho_pc
                    ? "Please enter valid postal code"
                    : FIELD_ERROR_TEXT
                }
                required
                custom="postal_code"
                disabled={offlineDisabled || disabled?.stage || btnLoading}
              />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

    </div>
  );
};

export default Initial;
